/* eslint-disable */
const sanityClient = require("@sanity/client");

const client = sanityClient({
  projectId: "kj5n9ivc",
  dataset: "production",
  apiVersion: "2021-06-07", // use a UTC date string
  token: "",
  useCdn: true, // `false` if you want to ensure fresh data
});

const ITEMS_PER_PAGE = 12;

const getAcademyMediaPaginated = (
  params = {},
  page = 1,
  textQuery = "",
  tagQuery = "",
  orderBy = "desc"
) => {
  const getPaginationString = () => {
    if (page === 1) {
      return `[0...${ITEMS_PER_PAGE}]`;
    } else if (page === 2) {
      return `[${ITEMS_PER_PAGE}...${ITEMS_PER_PAGE + ITEMS_PER_PAGE}]`;
    }
    return `[${ITEMS_PER_PAGE * page}...${
      ITEMS_PER_PAGE * page + ITEMS_PER_PAGE
    }]`;
  };

  const query = `
    *[_type == "zacademy" ${textQuery}${tagQuery}] | order(publishedAt ${orderBy})
    ${getPaginationString()}
    {
        _id,
        title,
        "body": body[style match 'normal'][0].children[].text,
        "slug": slug.current,
        "author": author->name,
        "category": category->title,
        "heroImage": heroImage.asset->url,
        tags[]->{_id, title, description}
    }`;

  return client
    .fetch(query, params)
    .then((response) => {
      //console.log("getAcademyMediaPaginated(): ", response);
      return response;
    })
    .catch((error) => console.log("getAcademyMediaPaginated()->error:", error));
};

const getZAcademyFeatured = async () => {
  return await fetch(
    "https://us-central1-zefi-cms.cloudfunctions.net/cafeItemsHubPage/en",
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("NEW!! getZAcademyFeatured(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getZAcademyMediaCount = (params = {}, textQuery = "", tagQuery = "") => {
  const query = `count(*[_type == "zacedemy" ${textQuery}${tagQuery}]{})`;
  return client
    .fetch(query, params)
    .then((response) => {
      //console.log("getZCafeCount()->response: ", response);
      return response;
    })
    .catch((error) => console.log("getZCafeCount()->error:", error));
};

const getZAcademyMediaBySlug = (slug, params = {}) => {
  const query = `
    *[_type == "zacademy" && slug.current == "${slug}"]
    [0]
    {
        _id,
        title,
        body,
        "slug": slug.current,
        "author": author->name,
        "heroImage": heroImage.asset->url,
        tags[]->{_id, title, description},
        publishedAt
    }`;
  return client
    .fetch(query, params)
    .then((response) => {
      //console.log("getZAcademyMediaBySlug() -> response: ", response);
      return response;
    })
    .catch((error) => console.log("getZAcademyMediaBySlug()->error:", error));
};

// FIRESTORE COMPLIANT API CALLS
const getAcademyMedia = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getAcademyMedia/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAcademyMedia(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedAcademyMedia = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedAcademyMedia/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //("getCafeMedia(): ", json);

      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedAcademyMediaByParentId = async (language_code, parent_id) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedAcademyMediaByParentId/${language_code}/${parent_id}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      if (json.code === 404) {
        throw new Error("404: Academy media not found");
      }
      return json;
    })
    .catch((error) => {
      throw error;
    });
};

const getAcademyFeatured = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getAcademyFeatured/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAcademyMediaFeatured(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getAcademyUpcoming = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getAcademyUpcoming/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAcademyMediaUpcoming(): ", json);

      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

//const errorJson = { id: "empty", data: "404" };

const getAcademyMediaBySlug = async (language_code, slug) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getAcademyMediaBySlug/${language_code}/${slug}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAcademyMedia(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

export {
  getAcademyMediaPaginated,
  getZAcademyFeatured,
  getZAcademyMediaCount,
  getZAcademyMediaBySlug,
  // firestore endpoints
  getLocalisedAcademyMedia,
  getLocalisedAcademyMediaByParentId,
  getAcademyMedia,
  getAcademyFeatured,
  getAcademyUpcoming,
  getAcademyMediaBySlug,
};
